<br>
<div class="col-md-10">
    <p-table #dt [columns]="cols" [value]="institutiontypes" [paginator]="false" [autoLayout]="true">
        <ng-template pTemplate="caption">
            <p class="rubrik">Institution Type</p>
            <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
                        (click)="exportToCSV()">Excel</button><button class="btn border" (click)="addCommittee();">Lägg till</button></div>
            <br>
            <div>
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
            <span class="ms-2">Antal poster: {{institutiontypes?.length}}</span>
            
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
            <tr *ngIf="groups.length > 0">
                <th *ngFor="let col of columns" [ngSwitch]="col.field">
                    <input *ngSwitchCase="'prefix'" pInputText type="text" [value]="dt.filters['prefix'] ? dt.filters['prefix'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                    <input *ngSwitchCase="'name'" pInputText type="text" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                    <input *ngSwitchCase="'branchId'" pInputText type="text" [value]="dt.filters['branchId'] ? dt.filters['branchId'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                    <input *ngSwitchCase="'description'" pInputText type="text" [value]="dt.filters['description'] ? dt.filters['description'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                    <p-select appendTo="body" *ngSwitchCase="'institutionGroupDescription'" [options]="groups" [style]="{'width':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'institutionGroupId', 'equals')"></p-select>
                </th>
                <th style="text-align: center;"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
            <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
                <td><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera aktuell institutionstyp"></i><i class="fa fa-edit" style="font-size:12px;margin-left:10px;" (click)="edit(rowData)"
                            title="Ändra aktuell institutionstyp"></i></span></td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog header="Editera institutionstyp" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-institution-type-edit [formdata]="formdata" [groups]="groups" (doSave)="saveInstitutionType($event)" (doCancel)="cancelEdit()"></app-admin-institution-type-edit>
</p-dialog>

<p-dialog header="Lägg till institutionstyp" [(visible)]="displayaddinstitutiontype" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-institution-type-add [formdata]="formdata" [groups]="groups" (doSave)="saveAddInstitutionType($event)" (doCancel)="cancelAdd()"></app-admin-institution-type-add>
</p-dialog>
